import { computed, Ref } from '@vue/composition-api'
import { ActionPaletteTabs } from '@/modules/ui/types'

const useActionPaletteTabs = (currentTabPanel: Ref<ActionPaletteTabs>) => {

  const isCasterPaletteVisible = computed(() => currentTabPanel.value === ActionPaletteTabs.Casters)
  const isCommentatorPaletteVisible = computed(() => currentTabPanel.value === ActionPaletteTabs.Commentators)
  const isLayoutPaletteVisible = computed(() => currentTabPanel.value === ActionPaletteTabs.Layout)
  const isPresetPaletteVisible = computed(() => currentTabPanel.value === ActionPaletteTabs.Preset)
  const isSettingsPaletteVisible = computed(() => currentTabPanel.value === ActionPaletteTabs.Settings)
  const isSwitcherPaletteVisible = computed(() => currentTabPanel.value === ActionPaletteTabs.Switcher)

  return {
    isCasterPaletteVisible,
    isCommentatorPaletteVisible,
    isLayoutPaletteVisible,
    isPresetPaletteVisible,
    isSettingsPaletteVisible,
    isSwitcherPaletteVisible
  }
}

export default useActionPaletteTabs
